import { Link } from 'react-router-dom';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';

// ===== 関連サイト / THE BUTLER 全面刷新（新デザイン憲章適用・_shared廃止・inline化） =====
// 実文は working tree 現行実文を保持。外部公式URL thebutler.jp は変更禁止。当ルートは pagesWithOwnFaq 登録済み＝FAQ自前描画。

const services = [
  { title: 'ハウスキーピング', en: 'Housekeeping', desc: '住居の管理や調理、洗濯、買い出し、お子様の送迎・見守りなど、暮らしの基盤を静かに整えます。', img: '/images/generated/jba-still-hatship-01.webp', alt: '山高帽と帆船模型の飾り棚' },
  { title: 'ビジネスフォロー', en: 'Business Support', desc: 'スケジュール管理や資料作成、会議の準備、送迎など、多忙な日々のビジネスを支えます。', img: '/images/generated/jba-fs-198-related_the-butler-v8.webp', alt: '多忙なビジネスを支える執事の秘書業務' },
  { title: 'イベント・接遇', en: 'Events & Reception', desc: '来賓のお出迎えやお見送り、給仕、空間演出など、特別な日のおもてなしを担います。', img: '/images/generated/jba-fs-199-related_the-butler-v8.webp', alt: '来賓を迎える特別な日の接遇を担う執事' },
  { title: 'バトラーコンシェルジュ', en: 'Butler Concierge', desc: 'VVIP・富裕層のお客様に向けた、オーダーメイドのサービスをご用意しています。', img: '/images/generated/jba-fs-200-related_the-butler.webp', alt: 'VVIPに向けたオーダーメイドの執事サービス' },
];

const faqs = [
  {
    q: 'THE BUTLER とはどのようなサービスですか？',
    a: 'THE BUTLER は、一般社団法人全日本執事協会が運営する執事によるおもてなしのサービスです。英国式執事の規律と品格に、日本ならではの細やかな礼節を重ねた、フルオーダー型のサービスを提供しています。',
  },
  {
    q: 'どのような内容を依頼できますか？',
    a: 'ハウスキーピング、スケジュール管理などのビジネスフォロー、来賓の接遇やイベント給仕、VVIP向けのバトラーコンシェルジュまで、暮らしとおもてなしを包括的に支えます。単なる家事代行ではなく、お客様が仕事や家族、休息に集中できる環境そのものを整えます。',
  },
  {
    q: '協会や執事アカデミーとの関係は？',
    a: 'THE BUTLER と日本執事アカデミーは、いずれも一般社団法人全日本執事協会を母体としています。アカデミーが育成した執事が品格あるサービスを届ける現場のひとつが THE BUTLER です。ご相談・お申し込みは公式サイト thebutler.jp が窓口となります。',
  },
];

const otherRelated = [
  { name: '日本執事アカデミー', role: '教育・養成機関', to: '/related/butler-academy' },
  { name: '執事ベル', role: '情報発信ブランド', to: '/related/butler-bell' },
];

const breadcrumbs = [
  { label: 'ホーム', href: '/' },
  { label: '関連サイト', href: '/related' },
  { label: 'THE BUTLER' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.08em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function RelatedTheButlerPage() {
  return (
    <Layout>
      {/* ===== ヒーロー ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/generated/jba-fs-201-related_the-butler-v8.webp" alt="サロンで来客を迎える正装の執事。THE BUTLERが提供する包括的なおもてなし" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">THE BUTLER</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.04em] mb-6">
              執事による、包括的なおもてなし
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95]">
              一般社団法人全日本執事協会が運営する、執事によるおもてなしのサービス。ご相談・お申し込みは公式サイト THE BUTLER が窓口となっています。
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* ===== I. THE BUTLER とは — リード＋画像 ===== */}
      <NavyBand no="I" ja="THE BUTLER とは" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.02em] mb-5">
                家事の代行ではなく、<span className="text-[#a38e65]">集中できる環境そのものを</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                THE BUTLER は、一般社団法人全日本執事協会が運営する執事サービスです。英国式執事の規律と品格に、日本ならではの細やかな礼節を重ねた、フルオーダー型のおもてなしを提供しています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95]">
                単なる家事の代行ではなく、お客様が本来向き合うべき仕事や家族、休息に集中できる環境そのものを整えることを大切にしています。主人が言葉にする前に必要を察し、静かに寄り添う――そうした先回りの奉仕が、THE BUTLER の執事サービスの本質です。
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/generated/jba-p-028-rel-residence.webp" alt="高級レジデンスで給仕する執事の様子" className="w-full h-[300px] sm:h-[400px] md:h-[460px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== II. 主なサービス内容 — 白カード（各ポイントに画像）===== */}
      <NavyBand no="II" ja="主なサービス内容" en="Services" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mb-10 text-left">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.02em] mb-5">
              暮らしとおもてなしを、<span className="text-[#a38e65]">四つの領域で</span>
            </h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95]">
              ハウスキーピングからビジネスフォロー、イベント接遇、VVIP向けのバトラーコンシェルジュまで。日常からハレの日まで、暮らしとおもてなしを包括的に支えます。
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
            {services.map((s, i) => (
              <article key={s.title} className="flex flex-col sm:flex-row border border-[#e2ddd2] overflow-hidden group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative sm:w-[42%] shrink-0 h-48 sm:h-auto min-h-[180px]">
                  <img src={s.img} alt={s.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                  <span className="absolute top-3 left-3 font-['Playfair_Display',serif] text-[#f8f6f0] text-2xl drop-shadow-lg">{String(i + 1).padStart(2, '0')}</span>
                </div>
                <div className="p-6 sm:p-7 flex flex-col justify-center text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1.5">{s.en}</span>
                  <h4 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl mb-3 leading-[1.4]">{s.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{s.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== III. 協会とのつながり — 紺パネル＋画像 ===== */}
      <NavyBand no="III" ja="協会とのつながり" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/generated/jba-p-029-rel-service-w2.webp" alt="アカデミーで育成された執事が現場で品格あるサービスを届ける様子" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.02em] mb-6">
                学びと実務が、<span className="text-[#d7b779]">同じ協会のもとで</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] mb-4">
                THE BUTLER は、一般社団法人全日本執事協会が運営する執事サービスです。日本執事アカデミーが育成した執事が、品格あるサービスを届ける現場のひとつが THE BUTLER です。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95]">
                学びと実務が同じ協会のもとでつながっていることは、協会の教育が机上のものではなく、実際のサービスの現場を見据えて設計されていることを意味します。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== IV. 公式サイトのご案内 — 外部CTA ===== */}
      <NavyBand no="IV" ja="公式サイトのご案内" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">THE BUTLER 公式サイト<span className="block text-lg text-[#8f7a56] mt-2 font-normal">ご相談・お申し込みの窓口</span></h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.95] max-w-2xl mx-auto mb-8">
              執事サービスのご相談・お申し込みは、THE BUTLER の公式サイトが窓口です。プランや料金の詳細もあわせてご案内しています。
            </p>
            <a href="https://thebutler.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              THE BUTLER 公式サイトを見る <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* ===== V. よくあるご質問（自前描画）===== */}
      <NavyBand no="V" ja="よくあるご質問" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.95] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== ほかの関連サイト＋CTA ===== */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">ほかの関連サイト</h3>
          <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">執事の学びや資格に関心をお持ちの方へ</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/qualifications" className={BTN08_ON_NAVY}>執事資格制度を見る</Link>
              <Link to="/contact" className={BTN08_ON_NAVY}>お問い合わせ</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
